<template>
  <div class="card vue-avatar-cropper-demo" id="image-cropper">
    <vs-avatar
      :id="(type =='#logo')?'logo':'cover'"
      class="border-2 border-solid border-grey con-vs-avatar text-6xl pick-avatar rounded-item"
      size="120px"
      :src="image_url"
    ></vs-avatar>
    <div style="height: 30px;">
      <div style="transform: translateY(-40px) translateX(15px);" v-if="message == 'uploading'">
        <img src="../../assets/images/loading.svg" />
      </div>
      <div v-else-if="message == 'completed'" class="flex align-center text-success text-sm">
        <feather-icon icon="CheckIcon" svgClasses="h-6 w-6 stroke-current text-success mr-2" />Upload success
      </div>
    </div>
    <avatar-cropper
      @uploading="handleUploading"
      @completed="handleCompleted"
      :upload-headers="headers"
      :trigger="type"
      :labels="labels"
      :upload-url="domain + '/v1/gocheckin/business/site/upload'"
      :cropper-options="coverOptions"
    />
    <div>
      <vs-button
        type="border"
        color="danger"
        class="btn-upload"
        @click="confirmDeleteAvatar"
        v-if="image_url"
        style="transform: translateX(7px);"
      >
        Delete Image
      </vs-button>
    </div>
  </div>
</template>

<script>
import AvatarCropper from "vue-avatar-cropper";
import { StringHelper } from "../../models/string_helper";
import { domain } from "../../axios";

export default {
  components: { AvatarCropper },
  name: "image-uploader",
  props: {
    image: {
      type: String,
      // default: null
      required: true
    },
    type: {
      type: String,
      required: false,
    }
  },
  created() {
    this.message = "ready";
  },
  data() {
    // console.log(this.image);
    return {
      message: "ready",
      labels: { submit: "Submit", cancel: "Cancel" },
      StringHelper,
      uploaded: false,
      image_url: this.image,
      domain: domain,
      coverOptions: {
        // aspectRatio: 1.777,
        autoCropArea: 1,
        viewMode: 1,
        movable: false,
        zoomable: false
      }
    };
  },
  methods: {
    // eslint-disable-next-line
    handleUploading(form, xhr) {
      this.message = "uploading";
    },
    // handleUploaded(response) {
    //   if (response.status == "success") {
    //     this.user.avatar = response.url;
    //     // Maybe you need call vuex action to
    //     // update user avatar, for example:
    //     // this.$dispatch('updateUser', {avatar: response.url})
    //     this.message = "user avatar updated.";
    //   }
    // },
    // eslint-disable-next-line
    handleCompleted(response, form, xhr) {
      this.message = "completed";
      this.uploaded = true;
      this.image_url = response[0].url;
      this.$emit("uploaded-done", {
        type: this.type,
        image_url: this.image_url
      });
    },
    // handlerError(message, type, xhr) {
    //   // console.log(message);
    //   // this.message = "Oops! Something went wrong...";
    // },
    confirmDeleteAvatar() {
      this.$vs.dialog({
        type: "confirm",
        title: "Confirmation",
        text: "Are you sure to delete this image?",
        accept: this.deleteAvatar
      });
    },
    deleteAvatar() {
      this.image_url = null;
      this.uploaded = false;
      this.$vs.notify({
        title: "Success",
        text: "Delete image success!",
        color: "success",
        position: "top-right"
      });
      this.$emit("uploaded-done", {
        type: this.type,
        image_url: "deleted"
      });
    }
  },
  computed: {
    headers() {
      return {
        Authorization: "Bearer " + localStorage.getItem("accessToken"),
        "G-ClientID": localStorage.getItem("domainId")
      };
    }
  }
};
</script>

<style lang="scss">
#image-cropper {
  .material-icons {
    font-size: 70px;
  }

  #logo, #cover {
    margin-left: 0;
  }
}
</style>